import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsUnterseiteEnergieV1(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Ebene_1"
      viewBox="0 0 351.25 82"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__cls-3{fill:#f28443}'
          }
        </style>
      </defs>
      <g
        data-name="Energie Sammlung Desktop"
        id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Energie_Sammlung_Desktop"
      >
        <g id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Group-3">
          <g id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Group-4">
            <path
              d="M147 60h23.01v-4.72h-17.52V44.15h16.12v-4.71h-16.12V28.36h17.31v-4.72h-22.79V60Zm35.26-16.19c0-4.35 2.66-6.84 6.36-6.84s5.79 2.36 5.79 6.32V60h5.31V42.65c0-6.75-3.71-10.28-9.29-10.28-4.1 0-6.78 1.9-8.04 4.79h-.34v-4.44h-5.1v27.27h5.31V43.8Zm36.55 16.74c5.95 0 10.16-2.93 11.36-7.37l-5.03-.91c-.96 2.58-3.27 3.89-6.29 3.89-4.54 0-7.6-2.95-7.74-8.2h19.39v-1.88c0-9.85-5.89-13.71-12.07-13.71-7.6 0-12.61 5.79-12.61 14.17 0 8.47 4.94 14.01 12.98 14.01Zm-7.67-16.57c.05-4.01 3.32-7.23 7.33-7.23 4.12 0 6.82 3.05 6.84 7.23h-14.17ZM236.66 60h5.31V43.34c0-3.57 2.75-6.14 6.52-6.14.93 0 1.86.11 2.77.32v-5.08c-.75-.08-1.5-.12-2.25-.12-3.09-.1-5.9 1.82-6.92 4.74h-.28v-4.33h-5.13V60Zm29.89 10.74c6.94 0 12.3-3.18 12.3-10.14V32.72h-5.2v4.42h-.39a8.296 8.296 0 0 0-7.9-4.78c-6.59 0-11.43 5.2-11.43 13.89s4.95 13.34 11.4 13.34c5.01 0 6.94-2.82 7.9-4.56h.34v5.36c0 4.21-2.93 6.07-6.96 6.07-4.42 0-6.14-2.22-7.08-3.73l-4.56 1.88c1.44 3.28 5.08 6.13 11.6 6.13Zm-.05-15.55c-4.74 0-7.21-3.64-7.21-9s2.42-9.3 7.21-9.3 7.12 3.78 7.12 9.3-2.54 9-7.12 9ZM286.21 60h5.31V32.73h-5.31V60Zm2.68-31.48c1.79.04 3.29-1.37 3.36-3.16a3.305 3.305 0 0 0-3.36-3.18c-1.8-.04-3.3 1.38-3.36 3.18.06 1.8 1.56 3.21 3.36 3.16Zm21.75 32.03c5.95 0 10.16-2.93 11.36-7.37l-5.02-.91c-.96 2.58-3.27 3.89-6.29 3.89-4.54 0-7.6-2.95-7.74-8.2h19.39v-1.88c0-9.85-5.9-13.71-12.07-13.71-7.6 0-12.61 5.79-12.61 14.17 0 8.47 4.94 14.01 12.98 14.01Zm-7.67-16.57c.05-4.01 3.32-7.23 7.33-7.23 4.12 0 6.82 3.05 6.84 7.23h-14.17Zm30.83-.18c0-4.35 2.66-6.84 6.36-6.84s5.79 2.36 5.79 6.32v16.71h5.31V42.64c0-6.75-3.71-10.28-9.29-10.28-4.1 0-6.78 1.9-8.04 4.79h-.34v-4.44h-5.1v27.27h5.31V43.79Z"
              data-name="Themen im Fokus-2"
              id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Themen_im_Fokus-2"
              style={{
                fill: '#005096',
              }}
            />
          </g>
        </g>
        <g id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Passive-2">
          <g id="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__Rectangle-2">
            <path
              d="M41 0h38c22.64 0 41 18.36 41 41s-18.36 41-41 41H41C18.36 82 0 63.64 0 41S18.36 0 41 0Z"
              style={{
                fill: 'none',
              }}
            />
            <path
              className="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__cls-3"
              d="M79 82H41C18.39 82 0 63.61 0 41S18.39 0 41 0h38c22.61 0 41 18.39 41 41s-18.39 41-41 41ZM41 2.5C19.77 2.5 2.5 19.77 2.5 41S19.77 79.5 41 79.5h38c21.23 0 38.5-17.27 38.5-38.5S100.23 2.5 79 2.5H41Z"
            />
          </g>
          <path
            className="MS_Klimadashboard_Icons_Unterseite_Energie_v1_svg__cls-3"
            d="M56.25 72.15a4.92 4.92 0 0 1-3.77-1.76 5.135 5.135 0 0 1-1.12-4.06c0-.06.02-.11.04-.17l4.75-16.17-6.94 2.9c-.06.03-.13.05-.19.06-2.18.52-4.51-.53-5.59-2.52-.87-1.6-.84-3.56.08-5.13l18.12-31.42s.05-.09.06-.1c.9-1.48 2.46-2.37 4.18-2.37 1.55 0 3.03.75 3.96 2.02.84 1.15 1.15 2.61.86 4.02l-5.45 18.63 8.19-2.85s.09-.03.14-.04c2.04-.45 4.24.53 5.3 2.37.87 1.52.9 3.42.06 4.95l-.16.27-9.87 15.29c-.37.58-1.15.75-1.73.37-.58-.37-.75-1.15-.37-1.73l9.94-15.4c.43-.78.41-1.74-.03-2.51-.51-.89-1.55-1.37-2.53-1.19l-10.41 3.62c-.44.15-.93.05-1.27-.27-.34-.32-.47-.81-.34-1.26l6.11-20.86c.12-.61-.04-1.37-.45-1.94-.46-.62-1.18-1-1.94-1-.84 0-1.6.44-2.05 1.17L45.68 46.54c-.48.82-.5 1.84-.05 2.67.54.98 1.65 1.52 2.73 1.3l9.26-3.87a1.253 1.253 0 0 1 1.69 1.5l-5.46 18.6c-.09.74.11 1.45.57 2 .47.55 1.14.87 1.86.87.84 0 1.62-.44 2.07-1.18l4.38-6.76c.38-.58 1.15-.74 1.73-.37.58.38.75 1.15.37 1.73l-4.36 6.73a4.95 4.95 0 0 1-4.18 2.35Z"
          />
        </g>
      </g>
    </svg>
  )
}
export default SvgMsKlimadashboardIconsUnterseiteEnergieV1
